import { connect, type ConnectedProps } from 'react-redux';
import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { type WithTranslation, withTranslation } from 'react-i18next';
import { compose } from '@reduxjs/toolkit';
import { APP_TITLE } from '@/config';
import ProfileAvatar from '@/components/ProfileAvatar';
import CustomLink from '@/components/CustomLink';
import { Logo } from '@/static';
import { user, logout } from '@/slices/user';
import { type RootState } from '@/store';
import styles from './styles';

type Props = ConnectedProps<typeof connector> & WithTranslation;

const AuthHeader = ({ t, user, logout }: Props) => {
  const handleLogout = () => {
    logout();
  };

  return (
    <Box component="header" sx={styles.root}>
      <Box sx={styles.left}>
        <CustomLink to="/" sx={styles.logoLink}>
          <Logo />
        </CustomLink>

        <Typography variant="h3" sx={styles.title}>
          {APP_TITLE}
        </Typography>
      </Box>

      {user && (
        <Box sx={styles.right}>
          <Box sx={styles.userInfo}>
            {(user?.alias || user?.full_name) && (
              <Typography variant="h5">
                {user.alias || user.full_name}
              </Typography>
            )}

            {user?.email && <Typography variant="h5">{user.email}</Typography>}
          </Box>

          <ProfileAvatar user={user} />

          <IconButton
            sx={styles.iconButton}
            title={t('LOGOUT')}
            onClick={handleLogout}
          >
            <LogoutIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

const connector = connect(
  (state: RootState) => ({
    user: user(state),
  }),
  {
    logout,
  },
);

export default compose(connector, withTranslation())(AuthHeader);
